import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchblogThunk } from "../redux/blogSlice";

const useBlogList = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setStatus("loading");
        const resultAction = await dispatch(fetchblogThunk());
        if (fetchblogThunk.fulfilled.match(resultAction)) {
          setData(resultAction.payload);
          setStatus("succeeded");
        } else {
          throw new Error(resultAction.error?.message || "Failed to load blogs");
        }
      } catch (err) {
        setError(err.message || "Failed to load blogs");
        setStatus("failed");
      }
    };
    fetchBlogs();
  }, [dispatch]);

  return { data, status, error };
};
export default useBlogList;

